import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { UserForm, mountForm, unmountForm } from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regSaga, regRoute } from '../../../store';
import { navigate } from '../../../root';
import { Link, useParams } from 'react-router-dom';
import { FormLayout } from './index';

const formKey = (spaceSlug, username) => `${spaceSlug}-${username}-user-form`;

regRoute('USER_EDIT_PAGE', '/spaces/edit/:spaceSlug/users/edit/:username');

regSaga(
  takeEvery('ENTER_USER_EDIT_PAGE', function* ({ payload }) {
    const { spaceSlug, username } = payload.params;
    yield call(mountForm, formKey(spaceSlug, username));
  }),
);

regSaga(
  takeEvery('LEAVE_USER_EDIT_PAGE', function* ({ payload }) {
    const { spaceSlug, username } = payload.params;
    yield call(unmountForm, formKey(spaceSlug, username));
  }),
);

const handleSave =
  ({ spaceSlug }) =>
  user => {
    navigate(`/spaces/edit/${spaceSlug}/users/edit/${user.username}`);
  };

export const SpaceUsersNew = () => {
  const { spaceSlug, username } = useParams();

  return (
    <UserForm
      spaceSlug={spaceSlug}
      username={username}
      fieldSet={[
        'username',
        'enabled',
        'spaceAdmin',
        'email',
        'displayName',
        'password',
        'passwordConfirmation',
        'allowedIps',
      ]}
      components={{
        FormLayout,
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Create User',
          cancelPath: `/spaces/edit/${spaceSlug}/users`,
        }),
      }}
      onSave={handleSave}
    >
      {({ form, initialized }) =>
        initialized && (
          <div className="app-content__main">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Spaces</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/spaces/edit/${spaceSlug}`}>{spaceSlug}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/spaces/edit/${spaceSlug}/users`}>Users</Link>
                </li>
                <li className="breadcrumb-item active">Create User</li>
              </ol>
            </nav>

            <div className="heading">
              <h1>Create User</h1>
            </div>
            <div className="content-container">{form}</div>
          </div>
        )
      }
    </UserForm>
  );
};
